// src/pages/PodcastsPage.js
import React from 'react';
import './PodcastsPage.css';

export function PodcastsPage() {
  const shows = [
    {
      id: '7JIcvflZ3nmo1bRC03QoMa',
      name: 'GenAI on GenAI in Supply Chain',
      description: 'AI-generated insights exploring GenAI in Supply Chain Management. Based on Professor Castillo\'s curriculum, this meta-perspective series teaches about AI\'s transformative role in supply chains while serving as a classroom exercise for evaluating AI-generated content accuracy.'
    },
    {
      id: '7ih7Gj0JC4FFl5GdvH7H9i',
      name: 'Logistics and Supply Chain Analytics',
      description: 'Companion to the undergraduate analytics course covering data visualization, forecasting, machine learning, inventory management, and network design. Learn how data drives supply chain decisions through practical, real-world applications.'
    },
    {
      id: '3yC8TDKB8mhaSFcdVRM1nn',
      name: 'Building a Sustainable Supply Chain',
      description: 'Explore how businesses create sustainable supply chains while maintaining competitive advantage. Examines strategies and best practices for transforming traditional supply chains to benefit both business and society.'
    }
  ];

  return (
    <div className="podcasts-page">
      <div className="container">
        <header className="page-header">
          <h1>Supply Chain Podcasts</h1>
          <p>AI-generated educational content from courses at The Ohio State University</p>
        </header>

        <div className="podcasts-intro">
          <p>
            These podcasts are generated using Google's NotebookLM and JellyPod.ai, showcasing the transformative 
            potential of AI in higher education. Each series accompanies actual courses taught by 
            Dr. Vince Castillo at Fisher College of Business.
          </p>
        </div>

        <div className="shows-grid">
          {shows.map(show => (
            <div key={show.id} className="show-card">
              <h2>{show.name}</h2>
              <p className="show-description">{show.description}</p>
              <div className="spotify-embed">
                <iframe
                  src={`https://open.spotify.com/embed/show/${show.id}?utm_source=generator&theme=0`}
                  width="100%"
                  height="352"
                  frameBorder="0"
                  allowFullScreen=""
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                  title={show.name}
                ></iframe>
              </div>
            </div>
          ))}
        </div>

        <div className="podcasts-note">
          <h3>About These Podcasts</h3>
          <p>
            All episodes are AI-generated using course materials and lectures. Listeners are encouraged 
            to critically evaluate the content as part of their learning experience.
          </p>
        </div>
      </div>
    </div>
  );
}